import { createContext } from 'react'

export const AnalyticsContext = createContext<Gallery.Analytics.IAnalytics | null>(null)
